import { ArrowSquareOutIcon as PhosphorArrowSquareOutIcon } from "@phosphor-icons/react/dist/ssr/ArrowSquareOut";

import { createAppIcon } from "@/components/createAppIcon";

export const OpenExternalIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowSquareOutIcon);
